<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg4 md4 sm6>          
            <v-card pa-0>              
              <v-divider></v-divider>
              <v-card-text class="">
                <v-form v-model="valid">  
                  <v-autocomplete
                      v-bind:items="kompetisi.items"
                      v-bind:filter="customFilter"                      
                      v-bind:search-input.sync="kompetisi.search"
                      item-text="name"
                      item-value="id"
                      v-model="formModel.kompetisi_id"
                      label="Kompetisi ID"
                      v-bind:error-messages="errors.collect('kompetisi_id')" 
                      v-validate="'required'"
                      data-vv-name="kompetisi_id" 
                      required
                      hide-no-data clearable
                      v-bind:loading="kompetisi.loading"                          
                  ></v-autocomplete>   
                  
                  <v-text-field
                      label="Nama Dapil"
                      name="name"                              
                      v-model="formModel.name"
                      v-validate="'required'"
                      data-vv-name="name"     
                      :error-messages="errors.collect('name')"  
                      required
                  ></v-text-field>
                  <v-text-field
                      label="Nomor Dapil"
                      name="nomor"                              
                      v-model="formModel.no"
                      v-validate="'required'"
                      type="number"
                      data-vv-name="no"     
                      v-bind:error-messages="errors.collect('no')"  
                      required
                  ></v-text-field>

                  <v-select
                    v-bind:items="tingkats"
                    v-validate="'required'"
                    data-vv-name="tingkat"     
                    v-bind:error-messages="errors.collect('tingkat')"           
                    v-model="formModel.tingkat"
                    label="Tingkat"    
                    required
                    item-text="name"
                    item-value="id"        
                    v-on:change="formModel.area_id = null; area.items =[]"
                  ></v-select>

                  <v-autocomplete
                      v-bind:items="area.items"
                      v-bind:filter="customFilter"                      
                      v-bind:search-input.sync="area.search"
                      item-text="name"
                      item-value="id"
                      v-model="formModel.area_id"
                      label="Area ID"
                      v-bind:error-messages="errors.collect('area_id')" 
                      v-validate="'required'"
                      data-vv-name="area_id" 
                      required
                      hide-no-data clearable
                      v-bind:loading="area.loading"                          
                  ></v-autocomplete>      

                  <v-text-field
                      label="Kuota Kursi"
                      name="kuota"                              
                      v-model="formModel.kuota"
                      v-validate="'required'"
                      type="number"
                      data-vv-name="kuota"     
                      v-bind:error-messages="errors.collect('kuota')"  
                      required
                  ></v-text-field>
                  
                  <div class="form-btn">
                    <v-btn v-if="!isUpdate" @click="save(isUpdate)" color="success">Create</v-btn>
                    <v-btn v-else @click="save(isUpdate)" color="primary">Update</v-btn>                                                                                            
                  </div>                        
                </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>      
          <v-flex lg8 md8 sm6>
            <v-card pa-0>                            
              <v-card-text class="">
                <span class="subheading">Detail Area</span>
                <v-divider></v-divider>
                <v-alert v-if="alert" v-bind:value="alert.status" color="warning" icon="priority_high" dark>
                  {{alert.msg}}
                </v-alert>
                <div class="v-table__overflow" v-click-outside="notMagic">
                  <v-btn @click="newDtl()" icon class="primary--text mb-2" style="position: absolute; right:10px; " ><v-icon>add</v-icon></v-btn>                
                  <v-data-table
                      :headers="headersDtl"
                      :items="formModel.dapilDtls"
                      :loading="loading"
                      hide-actions
                      class="elevation-1"                         
                  >                                
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>                             
                    <template slot="items" slot-scope="props" >
                      <td @click="isMagic(props)">{{props.index+1}}</td>
                      <td @click="isMagic(props)">
                        <v-select
                          solo hide-details
                          v-bind:items="detail[props.index].tingkats"
                          v-model="props.item.tingkat"
                          label="Tingkat"    
                          item-text="name"
                          item-value="id"                        
                          v-bind:ref="'dtl'+props.index"
                          v-if="props.item.magic"                           
                          v-on:change="props.item.area_id = null; detail[props.index].areas = []"
                        ></v-select>
                        <span class="results-as-you-type" v-else>
                          {{nameTingkat(props.item.tingkat)}} 
                        </span>
                        <!--<v-autocomplete
                            v-bind:items="tingkats"
                            v:filter="customFilter"                                        
                            item-text="name"
                            item-value="id"
                            v-model="props.item.coa_id"                                        
                            v-if="props.item.magic" 
                            @keyup.ctrl.up="keyup('up', 'coa', (props.index-1))"
                            @keyup.ctrl.down="keyup('down', 'coa', (props.index+1))"                                        
                            @keyup.enter="keyup('enter', 'deb', (props.index))"
                            @keyup.ctrl.enter="submitData"
                            :ref="'coa'+props.index"
                        ></v-autocomplete>-->  
                        
                      </td>
                      <td @click="isMagic(props)">
                        <v-autocomplete
                          solo hide-details
                          v-bind:items="detail[props.index].areas"
                          v-bind:filter="customFilter"                      
                          v-bind:search-input.sync="detail[props.index].areaSearch"
                          item-text="name"
                          item-value="id"
                          v-model="props.item.area_id"
                          label="Area ID"
                          hide-no-data clearable
                          v-bind:loading="detail[props.index].areaLoading" 
                          v-if="props.item.magic"        
                          @change="setTabular(props.item.area_id, props.index)"
                        ></v-autocomplete>  
                        <span class="results-as-you-type"
                          v-else>{{ props.item.area }} 
                        </span>
                      </td>
                      <td class="text-xs-right">                                    
                        <v-btn v-on:click="delDtl(props)" icon class="pink--text" small>
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </td>                                
                    </template>
                  </v-data-table> 
                </div>
              </v-card-text>
            </v-card>  
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>         
import Model  from '@/apps/frc/models/Dapil';
import direct from '@/util/directives';

var model = new Model();

export default {
  directives : direct, 
  $_veeValidate: {
    validator: 'new'
  },    
  data: () => ({     
    isUpdate : false,
    area : {      
      items:[],
      search:null,
      loading:false,
    },  
    
    kompetisi : {      
      items:[],
      search:null,
      loading:false,
    },  
    
    tingkats:[],
    formModel: {
      kompetisi_id : null,
      no : null,          
      name    : null,
      tingkat : 1,
      area_id : null,
      kuota : null,
      dapilDtls : [],
    },  
    detail:[],
    headersDtl:[
      {text:'No', value:'no'},
      {text:'Tingkat', value:'tingkat'},
      {text:'Area ID', value:'area_id'},
      {text:'', value:'action'},
    ],                             
    valid: true,
    loading : false,    
    alert : null,
  }),
  watch: {  
    formModel : {
      handler(newVal, oldVal){        
        if(newVal.area_id && newVal.tingkat){
          this.area.loading = true;            
          model.areas({'AreaSearch[id]':newVal.area_id,tingkat :newVal.tingkat}).then(res=>{                             
            this.area.items = res;              
            this.area.loading = false;
          });
        }
        if(newVal.kompetisi_id){
          this.kompetisi.loading = true;            
          model.kompetisis({'KompetisiSearch[id]':newVal.kompetisi_id}).then(res=>{                             
            this.kompetisi.items = res;              
            this.kompetisi.loading = false;
          });
        }
      },
      deep:true,
    },          
    detail(newVal){
      newVal.forEach((item,i)=>{
        this.$watch(['detail', i, 'areaSearch'].join('.'), (search) => {
          let prop = this.formModel.dapilDtls[i];
          if(search && prop.tingkat){
            this.detail[i].areaLoading = true; var parent_id = prop.tingkat === (this.formModel.tingkat+1)? this.formModel.area_id : null;            
            model.areas({'AreaSearch[name]':search,tingkat :prop.tingkat,'AreaSearch[parent_id]':parent_id}).then(res=>{                             
              this.detail[i].areas = res;              
              this.detail[i].areaLoading = false;
            });
          }
        });                
      });                   
    },
  },    
  created () {
    this.setTingkats();
    this.$watch(['area','search'].join('.'), (val)=>{
      this.area.loading = true; 
      model.areas({tingkat:this.formModel.tingkat,'AreaSearch[name]':val}).then(res=>{
        this.area.items   = res;
        this.area.loading = false;
      });      
    });
    this.$watch(['kompetisi','search'].join('.'), (val)=>{
      this.kompetisi.loading = true; 
      model.kompetisis({'KompetisiSearch[name]':val}).then(res=>{
        this.kompetisi.items   = res;
        this.kompetisi.loading = false;
      });      
    });
  },    
  mounted () {
    this.init();        
  }, 
  methods : {                
    init(){            
      if(this.$route.query.id){
        this.isUpdate  = true;
        model.one({id : this.$route.query.id }).then(data => {                  
          Object.assign(this.formModel, data === null ? {}:data); 
          this.formModel.dapilDtl.forEach((item,i)=>{this.newDtl(item, i);});
          //this.getView();
        });                                               
      }            
      this.$validator.localize('en', this.dictionary); 
      //this.formModel.date = this.$moment().format('YYYY-MM-DD');
    },       
    
    async save(isUpdate = false) {     
        this.alert = null;
        this.$validator.validateAll();    
        this.formModel.time = this.$moment().valueOf();
        this.formModel.info = null;            
        if( !this.errors.any() ) {
            var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
            if(res.status === 200){  
                this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                this.$router.go(-1);                    
            } else {
                var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                this.$swal({type: 'error', title: title, text: text});                    
            }
        }             
    },
    
    validate(data){        
        data.forEach( (item) => {
            if(item.field !== 'dapilDtls'){
              this.$validator.errors.add({field : item.field,msg : item.message});
            } else {
              this.alert = {status: true, msg: item.message, field : item.field};
            }
        });
    },            
    
    customFilter (item, queryText, itemText) {
      const textOne = item.name.toLowerCase()
      //const textTwo = item.abbr.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1; 
    }, 
        
    setTingkats(){
      model.tingkats().then(data =>{
        this.tingkats = data;                               
      });
    },

    nameTingkat(id){
      var result = '';
      this.tingkats.forEach(item=>{if(id === item.id){result = item.name}});
      return result;
    },    
    
    newDtl(d = null, i = null){
      this.notMagic();               
            
      this.formModel.dapilDtls.push({        
        id : d ? d.id : null,
        dapil_id : d ? d.dapil_id :null,
        tingkat : d ? d.tingkat : parseInt(this.formModel.tingkat)+1,
        area_id : d ? d.area_id :null,
        magic : true,        
      });                              
      
      let tingkats = [];
      this.tingkats.forEach((item)=>{if(item.id > this.formModel.tingkat)tingkats.push(item)});
      
      this.detail.push({
        tingkats : tingkats,
        areas:[],
        areaSearch:null,
        areaLoading:false,        
      });      
      
      if(d && d.area_id){        
        this.setTabular(d.area_id, i);        
      }
    },
    
    setTabular(area_id, i){      
      let prop = this.formModel.dapilDtls[i];
            
      prop.area = null;   
      if(area_id){
        this.detail[i].areaLoading = true; 
        model.areas({tingkat:prop.tingkat,'AreaSearch[id]':prop.area_id}).then(res=>{
          res.forEach((item)=>{
            prop.area = item.name;
          });
          this.detail[i].areas = res;
          this.detail[i].areaLoading = false;
        });      
      }
    },

    delDtl(props){            
      this.formModel.dapilDtls.splice(props.index, 1);   
      this.detail.splice(props.index, 1);   
    }, 
    
    isMagic(props){     
      props.item.magic = true;
      this.notMagic(props.index);            
    },

    notMagic(exc = null){
      this.formModel.dapilDtls.forEach((item, index)=>{
        if(exc !== index){
          this.formModel.dapilDtls[index].magic = false;
        }
      });               
    }                            
  }
}
</script>
<style>
.tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
    padding: 0 4px;
}
</style>  